import { useState } from 'react'
import { useAuthStore } from '../../store/authStore'
import back_app from '../../lib/back_app'


export default function Org_select() {
  let { orgs, org_id_select } = useAuthStore()
  let [switching, switching_set] = useState(false)
  let [err, err_set] = useState<string | null>(null)
  let org_ids = Object.keys(orgs)
  if (org_ids.length < 2)
    return null

  let on_change = async (org_id: string)=>{
    if (switching || org_id == org_id_select)
      return
    switching_set(true)
    err_set(null)
    try {
      let res = await back_app.user_set('org_id_select', org_id)
      if (res?.err && res.err != 'org_id_select_already') {
        err_set(res.err)
        switching_set(false)
        return
      }
      window.location.reload()
    } catch(e: any) {
      err_set(e?.message || 'failed')
      switching_set(false)
    }
  }

  return (
    <div className="mb-6 text-left">
      <label className="block text-xs font-semibold text-gray-400 uppercase
        tracking-wide mb-1">Organization</label>
      <select
        value={org_id_select}
        disabled={switching}
        onChange={e=>on_change(e.target.value)}
        className="w-full px-4 py-2 rounded-xl border border-gray-300
          focus:outline-none focus:ring-2 focus:ring-[#0066FF] text-gray-900
          disabled:opacity-60"
      >
        {org_ids.map(oid=>(
          <option key={oid} value={oid}>{orgs[oid].lbl}</option>
        ))}
      </select>
      {err && <p className="text-red-600 text-sm mt-1">{err}</p>}
    </div>
  )
}